import { z } from "zod";
import { normalizeEmail, normalizeName } from "@/shared/utils/input-normalization";

/** `z.string` that is normalised (trim+lowercase) before the email check. */
const emailField = (required = "Introduce tu email") =>
  z
    .string()
    .min(1, required)
    .transform(normalizeEmail)
    .pipe(z.string().email("Email no válido"));

export const LoginSchema = z.object({
  email: emailField(),
  password: z.string().min(6, "Mínimo 6 caracteres"),
});

export type LoginValues = z.infer<typeof LoginSchema>;

export const ForgotPasswordSchema = z.object({
  email: emailField(),
});
export type ForgotPasswordValues = z.infer<typeof ForgotPasswordSchema>;

export const AcceptInviteSchema = z
  .object({
    password: z.string().min(8, "Mínimo 8 caracteres"),
    confirmPassword: z.string().min(8, "Mínimo 8 caracteres"),
  })
  .refine((v) => v.password === v.confirmPassword, {
    path: ["confirmPassword"],
    message: "Las contraseñas no coinciden",
  });
export type AcceptInviteValues = z.infer<typeof AcceptInviteSchema>;

export const ClaimPreviewSchema = z
  .object({
    name: z
      .string()
      .transform(normalizeName)
      .pipe(z.string().min(2, "Introduce tu nombre")),
    email: emailField(),
    password: z.string().min(8, "Mínimo 8 caracteres"),
    confirmPassword: z.string().min(8, "Mínimo 8 caracteres"),
  })
  .refine((v) => v.password === v.confirmPassword, {
    path: ["confirmPassword"],
    message: "Las contraseñas no coinciden",
  });
export type ClaimPreviewValues = z.infer<typeof ClaimPreviewSchema>;

export const ChangePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, "Introduce tu contraseña actual"),
    newPassword: z.string().min(8, "Mínimo 8 caracteres"),
    confirmNewPassword: z.string().min(8, "Mínimo 8 caracteres"),
  })
  .refine((v) => v.newPassword === v.confirmNewPassword, {
    path: ["confirmNewPassword"],
    message: "Las contraseñas no coinciden",
  })
  .refine((v) => v.newPassword !== v.currentPassword, {
    path: ["newPassword"],
    message: "La nueva contraseña debe ser distinta de la actual",
  });
export type ChangePasswordValues = z.infer<typeof ChangePasswordSchema>;

export const DeleteAccountSchema = z.object({
  // The user must type their email to confirm — destructive guard that
  // prevents accidental clicks. Also required for re-auth on
  // password accounts. Empty string allowed in the schema; the form
  // handler enforces the typed-confirmation match against the live email.
  confirmEmail: z.string().min(1, "Confirma tu email para continuar"),
  currentPassword: z.string().optional(),
});
export type DeleteAccountValues = z.infer<typeof DeleteAccountSchema>;
